module.exports = __webpack_public_path__ + "static/img/gongzhonghao.6b4ae07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gongzhonghao.png
// module id = FNDd
// module chunks = 16